import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import { Magento2_CurrencyEnum } from '@__generated__/globalTypes';
import type * as Types from '@__graphql__/types';

const defaultOptions = {} as const;
export type ShippingAddressesQueryVariables = Types.Exact<{
  cartId: Types.Scalars['String'];
}>;

export type ShippingAddressesQuery = {
  magento2?: {
    cart?: {
      shippingAddresses: Array<{
        __typename: 'Magento2_ShippingCartAddress';
        selectedShippingMethod?: {
          amount: {
            value?: number | null;
            currency?: Magento2_CurrencyEnum | null;
          };
          amountInclTax: {
            value?: number | null;
            currency?: Magento2_CurrencyEnum | null;
          };
        } | null;
      } | null>;
    } | null;
  } | null;
};

export const ShippingAddressesDocument = gql`
  query ShippingAddresses($cartId: String!) {
    magento2 {
      cart(cart_id: $cartId) {
        shippingAddresses {
          selectedShippingMethod {
            amount {
              value
              currency
            }
            amountInclTax {
              value
              currency
            }
          }
          __typename
        }
      }
    }
  }
`;

/**
 * __useShippingAddressesQuery__
 *
 * To run a query within a React component, call `useShippingAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useShippingAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShippingAddressesQuery({
 *   variables: {
 *      cartId: // value for 'cartId'
 *   },
 * });
 */
export function useShippingAddressesQuery(
  baseOptions: Apollo.QueryHookOptions<
    ShippingAddressesQuery,
    ShippingAddressesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ShippingAddressesQuery,
    ShippingAddressesQueryVariables
  >(ShippingAddressesDocument, options);
}
export function useShippingAddressesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ShippingAddressesQuery,
    ShippingAddressesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ShippingAddressesQuery,
    ShippingAddressesQueryVariables
  >(ShippingAddressesDocument, options);
}
export type ShippingAddressesQueryHookResult = ReturnType<
  typeof useShippingAddressesQuery
>;
export type ShippingAddressesLazyQueryHookResult = ReturnType<
  typeof useShippingAddressesLazyQuery
>;
export type ShippingAddressesQueryResult = Apollo.QueryResult<
  ShippingAddressesQuery,
  ShippingAddressesQueryVariables
>;
